import React, {
  Dispatch,
  SetStateAction,
  useState,
  useCallback,
  // useEffect
} from 'react';

import { CGCollection, CGProduct } from '../types/shopify';
import shopifyClient from '../lib/shopifyClient';
// import { oneSentence } from '../lib/misc';
// import { LoremIpsum } from 'lorem-ipsum';
import debug from 'debug';
import { getShopifyCollections, getShopifyCollectionByHandle, getShopifyProductByHandle } from 'lib/amplify';
import { getShopifyProxyProductHandleBySKU } from 'lib/shopifyproxy';
const d = debug('collectionsContext');
// const lorem = new LoremIpsum({
//   sentencesPerParagraph: {
//     max: 8,
//     min: 4,
//   },
//   wordsPerSentence: {
//     max: 16,
//     min: 4,
//   },
// });
interface ICollectionContextInterface {
  collections: CGCollection[];
  haveCollections: boolean;
  loadCollections: () => void;
  setCollections: Dispatch<SetStateAction<CGCollection[]>>;
  getCollectionByHandle: (handle: string) => CGCollection | undefined;
  loadCollectionByHandle: (handle: string) => Promise<CGCollection | undefined>;
  // getProductById: (productId: string) => CGProduct | undefined;
  // getProductByHandle: (handle: string) => CGProduct | undefined;
  loadProductByHandle: (handle: string) => Promise<CGProduct | undefined>;
  loadProductById: (handle: string) => Promise<CGProduct | undefined>;
  loadProductHandleByVariantSKU: (variantSKU: string) => Promise<string | undefined>;
}

export const collectionsContext = React.createContext<ICollectionContextInterface>({
  collections: [],
  haveCollections: false,
  loadCollections: () => undefined,
  setCollections: () => [],
  getCollectionByHandle: () => undefined,
  loadCollectionByHandle: () => Promise.resolve(undefined),
  // getProductById: () => undefined,
  // getProductByHandle: () => undefined,
  loadProductByHandle: () => Promise.resolve(undefined),
  loadProductById: () => Promise.resolve(undefined),
  loadProductHandleByVariantSKU: () => Promise.resolve(undefined),
});

const { Provider } = collectionsContext;

const CollectionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [collections, setCollections] = useState<CGCollection[]>([]);
  const [haveCollections, setHaveCollections] = useState<boolean>(false);

  const loadCollections = useCallback(async () => {
    const collectionData = await getShopifyCollections();
    d('loadCollections', collectionData);
    setCollections(collectionData);
    setHaveCollections(true);
  }, []);

  // Do not load entire collection DB...
  // useEffect(() => {
  //   loadCollections();
  // }, [loadCollections]);

  const getCollectionByHandle = useCallback(
    (handle: string): CGCollection | undefined => {
      return collections.find((Collection) => Collection.handle === handle);
    },
    [collections],
  );

  // Added useCallback to stop double renders...
  const loadCollectionByHandle = useCallback(async (handle: string): Promise<CGCollection | undefined> => {
    const Collection = await getShopifyCollectionByHandle(handle);
    return Collection;
  }, []);

  // const getProductById = useCallback(
  //   (productId: string): CGProduct | undefined => {
  //     return collections.flatMap((collection) => collection.products).find((product) => product.id === productId);
  //   },
  //   [collections],
  // );

  // const getProductByHandle = useCallback(
  //   (handle: string): CGProduct | undefined => {
  //     return collections.flatMap((collection) => collection.products).find((product) => product.handle === handle);
  //   },
  //   [collections],
  // );

  const loadProductByHandle = useCallback(async (handle: string): Promise<CGProduct | undefined> => {
    // @ts-ignore
    const Product: CGProduct = await getShopifyProductByHandle(handle);
    if (!Product) throw new Error('NOT_FOUND');
    d('fetched', Product);
    // if (product.images && product.images[0]) product.featuredImage = product.images[0];
    return Product;
  }, []);

  const loadProductById = useCallback(async (id: string): Promise<CGProduct | undefined> => {
    // @ts-ignore
    const product: CGProduct = await shopifyClient.product.fetch(id);
    if (!product) throw new Error('NOT_FOUND');
    d('fetched', product);
    if (product.images && product.images[0]) product.featuredImage = product.images[0];
    return product;
  }, []);

  return (
    <Provider
      value={{
        collections,
        haveCollections,
        loadCollections,
        setCollections,
        getCollectionByHandle,
        loadCollectionByHandle,
        // getProductById,
        // getProductByHandle,
        loadProductByHandle,
        loadProductById,
        loadProductHandleByVariantSKU: getShopifyProxyProductHandleBySKU,
      }}
    >
      {children}
    </Provider>
  );
};

export default CollectionsProvider;
